/* eslint-disable no-unused-vars */
import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import fitMissionServices from '../../../../../services/fit-mission.services';
import { missionRewardBannerFormDefaultValues } from '../dto/missionRewardBanner';
import LegacyMissionRewardBannerForm from '../form/LegacyMissionRewardBannerForm';

const LegacyMissionRewardBannerModal = ({ open, handleClose }) => {
  const { watch, handleSubmit, reset } = useFormContext();
  const queryClient = useQueryClient();

  const { mutate: createBanner } =
    fitMissionServices.useMutationCreateMissionRewardBanner(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-mission-reward-banner'],
        refetchType: 'all',
      });
      AlertSuccess('เพิ่มข้อมูลสำเร็จ');
      reset(missionRewardBannerFormDefaultValues);
      handleClose();
    });

  const { mutate: editBanner } =
    fitMissionServices.useMutationUpdateMissionRewardBanner(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-mission-reward-banner'],
        refetchType: 'all',
      });
      AlertSuccess('แก้ไขข้อมูลสำเร็จ');
      reset(missionRewardBannerFormDefaultValues);
      handleClose();
    });

  const _HandleSubmit = handleSubmit((data) => {
    const bannerData = {
      image: data.image,
      title: data.title,
      description: data.description,
      url: data.url,
      startDate: new Date(data.startDate),
      endDate: new Date(data.endDate),
      display: data.display,
    };

    if (watch('formType') === 'create') {
      createBanner(bannerData);
    } else if (watch('formType') === 'edit') {
      editBanner({ id: data.id, data: bannerData });
    }
  });

  return (
    <Modal
      title={
        watch('formType') === 'create'
          ? 'เพิ่มแบนเนอร์รางวัล'
          : 'แก้ไขแบนเนอร์รางวัล'
      }
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <LegacyMissionRewardBannerForm />
    </Modal>
  );
};

export default LegacyMissionRewardBannerModal;
